import { render, staticRenderFns } from "./CheckoutHeader.vue?vue&type=template&id=25af2bd0&scoped=true&"
import script from "./CheckoutHeader.vue?vue&type=script&lang=js&"
export * from "./CheckoutHeader.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutHeader.vue?vue&type=style&index=0&id=25af2bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../nonspa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25af2bd0",
  null
  
)

/* custom blocks */
import block0 from "./CheckoutHeader.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(component)

component.options.__file = "CheckoutHeader.vue"
export default component.exports